import styled from "styled-components";
export const SCROLL_UI = `
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #61707f;
    border-radius: 10px;
  }
  ::-webkit-scrollbar {
    width: 6px;
    height: 50px;
    border-radius: 3px;
  }
`;

export const PageContainer = styled.div``;
